import HorizontalProductList from './horizontal-product-list-view'

export default HorizontalProductList
